<template>
  <div v-if="isDev" class="fixed bottom-4 right-4 z-50">
    <!-- Toggle button -->
    <button
      class="btn btn-primary shadow-lg rounded-full w-12 h-12 flex items-center justify-center"
      @click="open = !open"
      :title="open ? 'Close Dev Panel' : 'Open Dev Panel'"
    >
      <svg
        v-if="!open"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="w-6 h-6 fill-current"
      >
        <path
          d="M10.325 4.317a1 1 0 0 1 1.35-.436l.084.05 1.517.973a8 8 0 0 1 3.368 4.396l.05.197 1.8.3a1 1 0 0 1 .812.99l-.004.1v1.946a1 1 0 0 1-.812.99l-.088.012-1.8.3a8.001 8.001 0 0 1-3.452 4.65l-.168.102-1.317.846a1 1 0 0 1-1.461-1.06l.017-.095.3-1.799a8.001 8.001 0 0 1-4.65-3.452l-.102-.168-1.8.3a1 1 0 0 1-1.09-.9l-.006-.098V11.18a1 1 0 0 1 .812-.99l.1-.012 1.8-.3a8.001 8.001 0 0 1 3.452-4.65l.168-.102 1.317-.846a1 1 0 0 1 1.366.137z"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="w-6 h-6 fill-current"
      >
        <path
          fill-rule="evenodd"
          d="M18.3 5.71a1 1 0 0 1 0 1.42L13.42 12l4.88 4.88a1 1 0 0 1-1.32 1.5l-.1-.08L12 13.42l-4.88 4.88a1 1 0 0 1-1.5-1.32l.08-.1L10.58 12 5.7 7.12a1 1 0 0 1 1.32-1.5l.1.08L12 10.58l4.88-4.88a1 1 0 0 1 1.42 0z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <!-- Panel -->
    <div
      v-if="open"
      class="mt-2 w-[340px] md:w-[420px] card bg-base-100 shadow-2xl border border-base-300"
    >
      <div class="card-body p-4">
        <div class="flex items-center justify-between mb-2">
          <h2 class="card-title text-sm">Dev Panel</h2>
          <span class="badge badge-outline">{{ modeLabel }}</span>
        </div>

        <div class="space-y-4 max-h-[70vh] overflow-auto">
          <!-- Theme Switcher -->
          <section>
            <h3 class="font-semibold text-sm mb-2">Theme</h3>
            <ThemeSwitcher />
          </section>

          <!-- Session Debugger -->
          <section>
            <h3 class="font-semibold text-sm mb-2">Session Debugger</h3>
            <SessionDebugger />
          </section>

          <!-- Env info (compact) -->
          <section>
            <h3 class="font-semibold text-sm mb-2">Env</h3>
            <div class="text-xs opacity-70 space-y-1">
              <div>VITE_API_BASE_URL: {{ env.VITE_API_BASE_URL || 'n/a' }}</div>
              <div>
                VITE_SUPERTOKENS_WEBSITE_DOMAIN: {{ env.VITE_SUPERTOKENS_WEBSITE_DOMAIN || 'n/a' }}
              </div>
              <div>APP_NAME: {{ env.VITE_APP_NAME || 'Bostello Admin Interface' }}</div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue'
  import ThemeSwitcher from './ThemeSwitcher.vue'
  import SessionDebugger from './SessionDebugger.vue'

  const env = (import.meta as any).env || {}
  const isDev = !!env?.DEV
  const open = ref(false)
  const modeLabel = computed(() => (isDev ? 'development' : 'production'))
</script>

<style scoped>
  /***** no extra styles; rely on DaisyUI *****/
</style>
